// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3ebM6","col":"styles_col__3XotK"};